<script setup lang="ts">
/**
 * Aura AGM (MULTIPLE shareholders) — AGM Documents. 템플릿 docx 를 그대로 재현.
 *   1 DRW · 2 Notice of AGM · 3 Consent to Short Notice(s.177(3)(a)) ·
 *   4 Minutes of AGM(Chairman) · 5 Attendance List · 6 Statement by Small Company(s.205C) · 7 Solvency Declaration.
 * cdd/서명 컴포넌트는 형제 `agm` 모듈 것을 재사용(공유 엔진). 이사 서명 = agm_Signers([[Signers]]+directors 루프),
 * 멤버 서명 = agm_member_Signers(members 루프), 의장 = chairman_name.
 */
import CddVarField from '../../agm/cdd/CddVarField.vue';
import AgmSigners from '../../agm/cdd/AgmSigners.vue';
import AgmMemberSigners from './AgmMemberSigners.vue';
import '../../agm/docs/agmDoc.css';
</script>

<template>
  <div class="agm-doc">
    <!-- ════ 1. DIRECTORS' RESOLUTIONS IN WRITING ════ -->
    <div class="doc-head" style="text-align:center">
      <div style="font-weight:800"><CddVarField field-key="company_name" label="Company Name" /></div>
      <div class="doc-meta">(Incorporated In Singapore)</div>
      <div class="doc-meta">Company Registration No. <CddVarField field-key="company_registration_no" label="Registration No." /></div>
      <div class="doc-meta">(the &ldquo;Company&rdquo;)</div>
    </div>
    <div class="doc-title">DIRECTORS&rsquo; RESOLUTIONS IN WRITING</div>
    <div class="doc-sub">PURSUANT TO THE COMPANY'S CONSTITUTION</div>

    <div class="sec-title">UNAUDITED FINANCIAL STATEMENTS</div>
    <p class="doc-p">Resolved that the unaudited financial statements of the Company for the financial year ended
      <CddVarField field-key="financial_year_end" label="Financial Year End" /> together with the directors&rsquo; statement
      thereon be approved and that the said directors&rsquo; statement be signed by any two directors of the Company on behalf
      of the board of directors.</p>

    <div class="sec-title">SPECIAL BUSINESS FOR ANNUAL GENERAL MEETING</div>
    <p class="doc-p">Resolved that in addition to the ordinary business of the Annual General Meeting, the following resolution
      be proposed, by way of a special business, for adoption at the Annual General Meeting.</p>
    <p class="doc-p center"><b>ORDINARY RESOLUTION</b></p>
    <p class="doc-p center"><b>DIRECTORS&rsquo; FEE AND/OR DIRECTORS&rsquo; REMUNERATION</b></p>
    <p class="doc-p">That the directors&rsquo; fee and/or directors&rsquo; remuneration, if any, for the financial year ended
      <CddVarField field-key="financial_year_end" label="Financial Year End" />, as stated in the financial statements be and
      are hereby approved.</p>

    <div class="sec-title">ANNUAL GENERAL MEETING</div>
    <p class="doc-p">Resolved that any director be authorised to make the necessary arrangements to convene the Annual General
      Meeting of the Company.</p>

    <div class="sec-title">AUTHORITY TO E-FILE RETURNS</div>
    <p class="doc-p">Resolved that any officer of the Company or such other person(s) as directed by the directors be authorised
      to e-file the relevant returns relating thereto with the Accounting and Corporate Regulatory Authority, for and on behalf
      of the Company.</p>
    <p class="doc-p">Dated: <CddVarField field-key="resolution_date" label="Resolution Date" /></p>

    <div class="sec-title">DIRECTORS / SIGNATURES</div>
    <AgmSigners var-key="agm_Signers" board-label="Directors" />

    <!-- ════ 2. NOTICE OF ANNUAL GENERAL MEETING ════ -->
    <div class="doc-head" style="text-align:center;margin-top:24px">
      <div style="font-weight:800"><CddVarField field-key="company_name" label="Company Name" /></div>
      <div class="doc-meta">(Incorporated In Singapore)</div>
      <div class="doc-meta">Company Registration No. <CddVarField field-key="company_registration_no" label="Registration No." /></div>
      <div class="doc-meta">(the &ldquo;Company&rdquo;)</div>
    </div>
    <p class="doc-p">Registered Office: <CddVarField field-key="registered_office_address" label="Registered Office Address" /></p>
    <div class="doc-title">NOTICE OF ANNUAL GENERAL MEETING</div>
    <p class="doc-p">NOTICE IS HEREBY GIVEN that the Annual General Meeting of the Company will be held at:</p>
    <table class="cdd-tbl" style="width:auto">
      <tbody>
        <tr><td class="cdd-lcell">Venue</td><td>:&nbsp; <CddVarField field-key="meeting_venue" label="Meeting Venue" /></td></tr>
        <tr><td class="cdd-lcell">Date</td><td>:&nbsp; <CddVarField field-key="meeting_date" label="Meeting Date" /></td></tr>
        <tr><td class="cdd-lcell">Time</td><td>:&nbsp; <CddVarField field-key="meeting_time" label="Meeting Time" /></td></tr>
      </tbody>
    </table>
    <div class="sec-title">AGENDA</div>
    <p class="doc-p">To receive and adopt the unaudited financial statements of the Company for the financial year ended
      <CddVarField field-key="financial_year_end" label="Financial Year End" /> together with the directors&rsquo; statement thereon.</p>
    <p class="doc-p">To re-elect director.</p>
    <p class="doc-p">As special business to propose, and if thought fit, to pass the following resolution:-</p>
    <p class="doc-p center"><b>ORDINARY RESOLUTION</b></p>
    <p class="doc-p center"><b>DIRECTORS&rsquo; FEE AND/OR DIRECTORS&rsquo; REMUNERATION</b></p>
    <p class="doc-p">That directors&rsquo; fee and/or directors&rsquo; remuneration, if any, for the financial year ended
      <CddVarField field-key="financial_year_end" label="Financial Year End" />, as stated in the financial statements be and is hereby approved.</p>
    <p class="doc-p">To transact any other business which may properly be transacted at an Annual General Meeting.</p>
    <p class="doc-p">By Order Of The Board</p>
    <AgmSigners var-key="agm_Signers" board-label="Director" />
    <p class="doc-p">Date: <CddVarField field-key="notice_date" label="Notice Date" /></p>
    <div class="doc-note">
      Notes:<br />
      1. A member entitled to attend and vote at the above meeting is entitled to appoint a proxy to attend and vote instead of him. A proxy need not be a member of the Company.<br />
      2. A corporation which is a member of the Company may, by resolution of its directors, authorise any person to act as its representative at any meetings of the Company, and such representative shall be entitled to exercise the same powers on behalf of the corporation which he represents as if he had been an individual member of the Company.<br />
      3. The instrument appointing a proxy must be deposited at the registered office of the Company not less than <CddVarField field-key="proxy_cut_off" label="Proxy Cut-off (hours)" /> hours before the meeting.
    </div>

    <!-- ════ 3. CONSENT TO SHORT NOTICE (s.177(3)(a)) — MEMBERS ════ -->
    <div class="doc-head" style="text-align:center;margin-top:24px">
      <div style="font-weight:800"><CddVarField field-key="company_name" label="Company Name" /></div>
      <div class="doc-meta">(Incorporated In Singapore)</div>
      <div class="doc-meta">Company Registration No. <CddVarField field-key="company_registration_no" label="Registration No." /></div>
      <div class="doc-meta">(the &ldquo;Company&rdquo;)</div>
    </div>
    <p class="doc-p">Pursuant to Section 177(3)(a) of the Companies Act, we, the undersigned, being the members of the Company
      entitled to attend and vote at the Annual General Meeting of the Company to be held at:-</p>
    <table class="cdd-tbl" style="width:auto">
      <tbody>
        <tr><td class="cdd-lcell">Venue</td><td>:&nbsp; <CddVarField field-key="meeting_venue" label="Meeting Venue" /></td></tr>
        <tr><td class="cdd-lcell">Date</td><td>:&nbsp; <CddVarField field-key="meeting_date" label="Meeting Date" /></td></tr>
        <tr><td class="cdd-lcell">Time</td><td>:&nbsp; <CddVarField field-key="meeting_time" label="Meeting Time" /></td></tr>
      </tbody>
    </table>
    <p class="doc-p">hereby consent to the holding of the aforesaid meeting, notwithstanding that the notice was shorter than that
      required by Section 177(2) of the Companies Act and that the financial statements were unaudited and received by us less
      than 14 days before the date of the aforesaid meeting as required by Section 203(1) of the Companies Act.</p>
    <div class="sec-title">MEMBERS / SIGNATURES</div>
    <AgmMemberSigners board-label="Members" />

    <!-- ════ 4. MINUTES OF ANNUAL GENERAL MEETING (Chairman) ════ -->
    <div class="doc-head" style="text-align:center;margin-top:24px">
      <div style="font-weight:800"><CddVarField field-key="company_name" label="Company Name" /></div>
      <div class="doc-meta">(Incorporated In Singapore)</div>
      <div class="doc-meta">Company Registration No. <CddVarField field-key="company_registration_no" label="Registration No." /></div>
      <div class="doc-meta">(the &ldquo;Company&rdquo;)</div>
    </div>
    <div class="doc-title">MINUTES OF ANNUAL GENERAL MEETING</div>
    <table class="cdd-tbl" style="width:auto">
      <tbody>
        <tr><td class="cdd-lcell">Venue</td><td>:&nbsp; <CddVarField field-key="meeting_venue" label="Meeting Venue" /></td></tr>
        <tr><td class="cdd-lcell">Date</td><td>:&nbsp; <CddVarField field-key="meeting_date" label="Meeting Date" /></td></tr>
        <tr><td class="cdd-lcell">Time</td><td>:&nbsp; <CddVarField field-key="meeting_time" label="Meeting Time" /></td></tr>
        <tr><td class="cdd-lcell">Present</td><td>:&nbsp; As per attendance list</td></tr>
      </tbody>
    </table>
    <div class="sec-title">CHAIRMAN</div>
    <p class="doc-p"><CddVarField field-key="chairman_name" label="Chairman" /> was elected chairman of the meeting.</p>
    <div class="sec-title">NOTICE OF MEETING</div>
    <p class="doc-p">Notice of the meeting was taken as read.</p>
    <div class="sec-title">UNAUDITED FINANCIAL STATEMENTS</div>
    <p class="doc-p">It was resolved that the unaudited financial statements of the Company for the financial year ended
      <CddVarField field-key="financial_year_end" label="Financial Year End" /> together with the directors&rsquo; statement thereon
      be received and adopted.</p>
    <div class="sec-title">SPECIAL BUSINESS</div>
    <p class="doc-p center"><b>ORDINARY RESOLUTION</b></p>
    <p class="doc-p center"><b>DIRECTORS&rsquo; FEE AND/OR DIRECTORS&rsquo; REMUNERATION</b></p>
    <p class="doc-p">It was resolved that the directors&rsquo; fee and/or directors&rsquo; remuneration, if any, for the financial year ended
      <CddVarField field-key="financial_year_end" label="Financial Year End" />, as stated in the financial statements be and are hereby approved.</p>
    <div class="sec-title">RETIREMENT OF DIRECTOR</div>
    <p class="doc-p">It was resolved that all the Directors who retire in accordance with the Company&rsquo;s Constitution were
      re-elected as Directors of the Company.</p>
    <p class="doc-p">Confirmed by,</p>
    <div class="sign-block"><div class="sign-line"><CddVarField field-key="chairman_name" label="Chairman" /><br />Chairman of the meeting</div></div>

    <!-- ════ 5. ATTENDANCE LIST — MEMBERS ════ -->
    <div class="doc-head" style="text-align:center;margin-top:24px">
      <div style="font-weight:800"><CddVarField field-key="company_name" label="Company Name" /></div>
      <div class="doc-meta">(Incorporated In Singapore)</div>
      <div class="doc-meta">Company Registration No. <CddVarField field-key="company_registration_no" label="Registration No." /></div>
      <div class="doc-meta">(the &ldquo;Company&rdquo;)</div>
    </div>
    <div class="doc-title">ATTENDANCE LIST OF ANNUAL GENERAL MEETING</div>
    <table class="cdd-tbl" style="width:auto">
      <tbody>
        <tr><td class="cdd-lcell">Venue</td><td>:&nbsp; <CddVarField field-key="meeting_venue" label="Meeting Venue" /></td></tr>
        <tr><td class="cdd-lcell">Date</td><td>:&nbsp; <CddVarField field-key="meeting_date" label="Meeting Date" /></td></tr>
        <tr><td class="cdd-lcell">Time</td><td>:&nbsp; <CddVarField field-key="meeting_time" label="Meeting Time" /></td></tr>
      </tbody>
    </table>
    <div class="sec-title">MEMBERS / SIGNATURES</div>
    <AgmMemberSigners board-label="Members" />

    <!-- ════ 6. STATEMENT BY A SMALL COMPANY EXEMPT FROM AUDIT (s.205C) ════ -->
    <div class="doc-title" style="margin-top:24px">STATEMENT BY A SMALL COMPANY</div>
    <div class="doc-sub">EXEMPT FROM AUDIT REQUIREMENTS</div>
    <table class="cdd-tbl" style="width:auto">
      <tbody>
        <tr><td class="cdd-lcell">Name of Company</td><td>:&nbsp; <CddVarField field-key="company_name" label="Company Name" /> (the &ldquo;Company&rdquo;)</td></tr>
        <tr><td class="cdd-lcell">Registration No.</td><td>:&nbsp; <CddVarField field-key="company_registration_no" label="Registration No." /></td></tr>
        <tr><td class="cdd-lcell">Financial Year End</td><td>:&nbsp; <CddVarField field-key="financial_year_end" label="Financial Year End" /></td></tr>
      </tbody>
    </table>
    <p class="doc-p">We, the directors of the abovementioned company, hereby make the following statement &ndash;</p>
    <p class="doc-p indent">that the Company qualifies as a small company under Section 205C read with the Thirteenth Schedule;</p>
    <p class="doc-p indent">that no notice has been received under Section 205C(2) of the Companies Act in relation to the financial year; and</p>
    <p class="doc-p indent">the accounting and other records required by the Companies Act to be kept by the Company have been kept in accordance with Section 199 of the Companies Act.</p>
    <AgmSigners var-key="agm_Signers" board-label="Director" />
    <p class="doc-p">Dated: <CddVarField field-key="resolution_date" label="Resolution Date" /></p>

    <!-- ════ 7. DECLARATION BY DIRECTOR ON SOLVENCY ════ -->
    <div class="doc-title" style="margin-top:24px">DECLARATION BY DIRECTOR</div>
    <div class="doc-sub">ON SOLVENCY FOR A COMPANY WHICH IS EXEMPT FROM AUDIT REQUIREMENTS</div>
    <table class="cdd-tbl" style="width:auto">
      <tbody>
        <tr><td class="cdd-lcell">Name of Company</td><td>:&nbsp; <CddVarField field-key="company_name" label="Company Name" /> (the &ldquo;Company&rdquo;)</td></tr>
        <tr><td class="cdd-lcell">Registration No.</td><td>:&nbsp; <CddVarField field-key="company_registration_no" label="Registration No." /></td></tr>
        <tr><td class="cdd-lcell">Financial Year End</td><td>:&nbsp; <CddVarField field-key="financial_year_end" label="Financial Year End" /></td></tr>
      </tbody>
    </table>
    <p class="doc-p">I/We, the director(s) of the abovementioned company, hereby declare &ndash;</p>
    <p class="doc-p indent">the amount which is due to director, as indicated in the unaudited financial statements for the financial year ended
      <CddVarField field-key="financial_year_end" label="Financial Year End" /> (if any), will not claim such amount from the Company
      or request for repayment of the said amount from the Company during the period of 12 months immediately following the date of this statement.</p>
    <p class="doc-p indent">There are reasonable grounds to believe that the Company will be able to pay its debts as and when they fall due
      during the period of 12 months immediately following the date of this statement.</p>
    <AgmSigners var-key="agm_Signers" board-label="Director" />
    <p class="doc-p">Dated: <CddVarField field-key="resolution_date" label="Resolution Date" /></p>
  </div>
</template>
